import { LEADERBOARD_FETCH_CHUNK } from "#/shared/constants"

import createDappAsyncThunk from "../asyncThunk"
import {
  setMatsnetLeaderboard,
  setMatsnetLeaderboardFullyFetched,
  setMatsnetUserRank,
  setMatsnetUsers,
} from "../slices/matsnet"

export const fetchMatsnetLeaderboard = createDappAsyncThunk(
  "matsnet/fetchMatsnetLeaderboard",
  async (
    { start, end }: { start: number; end: number },
    { getState, dispatch, extra: { sdk } },
  ) => {
    const { fullLeaderboard: currentLeaderboard } = getState().matsnet

    const { leaderboard: leaderboardChunk, users } =
      await sdk.mezo.api.matsnet.getMatsnetLeaderboard(start, end)

    // Let's check if there is more entries in the database by checking following
    // chunk of leaderboard data
    const { leaderboard: nextLeaderboardChunk } =
      await sdk.mezo.api.matsnet.getMatsnetLeaderboard(
        end,
        end + LEADERBOARD_FETCH_CHUNK,
      )

    const offset = end - start

    if (start === 0 && currentLeaderboard.length > 0) {
      return false
    }

    if (leaderboardChunk.length === 0) {
      return true
    }

    const fullLeaderboard = [
      ...currentLeaderboard,
      ...leaderboardChunk,
      ...(leaderboardChunk.length < offset ? nextLeaderboardChunk : []),
    ]

    dispatch(setMatsnetUsers(users))
    dispatch(setMatsnetLeaderboard(fullLeaderboard))
    dispatch(
      setMatsnetLeaderboardFullyFetched(nextLeaderboardChunk.length === 0),
    )

    return leaderboardChunk.length < offset
  },
)

export const fetchUserMatsnetLeaderboardRank = createDappAsyncThunk(
  "leaderboard/fetchUserLeaderboardRank",
  async (_, { dispatch, extra: { sdk } }) => {
    const currentUser = await sdk.mezo.api.matsnet.getUserLeaderboardRank()

    dispatch(setMatsnetUserRank(currentUser))

    return {
      rank: currentUser.rank,
      positionChange: currentUser.positionChange,
    }
  },
)

export const stackMatsnetBtc = createDappAsyncThunk(
  "account/stackMatsnetBtc",
  async (
    { mats }: { mats: number },
    { extra: { sdk } },
  ): Promise<{ success: boolean; transactionHash?: string }> => {
    const response = await sdk.mezo.api.matsnet.stackMatsnetBtc(mats)

    return response
  },
)
